export default __webpack_public_path__ + "7812dba.png";